// src/pages/VerifyEmail.js
// Landing page for the links in verification and email-change emails.
import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { authAPI } from '../utils/api';
import { useStore } from '../store';
import AuthCard, { alertStyle, linkStyle } from '../components/AuthCard';

export default function VerifyEmail() {
  const { user, checkAuth } = useStore();
  const [state, setState] = useState({ status: 'working' });
  const started = useRef(false);

  useEffect(() => {
    // Links are single-use; React StrictMode runs effects twice in development,
    // and the second call would report the link as already used.
    if (started.current) return;
    started.current = true;

    const token = new URLSearchParams(window.location.search).get('token');
    window.history.replaceState(null, '', window.location.pathname); // keep it out of history
    if (!token) { setState({ status: 'error', message: 'This link is incomplete. Open it from your email again.' }); return; }

    authAPI.verifyEmail(token)
      .then(res => {
        setState({ status: 'done', email: res.data.email, changed: res.data.changed, accountStatus: res.data.status });
        checkAuth(); // refresh the signed-in user, if any, so the banner disappears
      })
      .catch(err => setState({ status: 'error', message: err.response?.data?.error || 'Could not verify this link.' }));
  }, [checkAuth]);

  const footer = user
    ? <Link to="/dashboard" style={linkStyle}>Go to dashboard</Link>
    : <Link to="/login" style={linkStyle}>Sign in</Link>;

  return (
    <AuthCard subtitle="Email verification" footer={state.status !== 'working' && footer}>
      {state.status === 'working' && <div style={{ display: 'flex', justifyContent: 'center' }}><div className="spinner" /></div>}
      {state.status === 'done' && (
        <div style={alertStyle('success')}>
          {state.changed
            ? <>Your sign-in email is now <strong>{state.email}</strong>.</>
            : <><strong>{state.email}</strong> is verified. Thanks!</>}
        </div>
      )}
      {state.status === 'done' && state.accountStatus === 'pending' && (
        <p style={{ fontSize: 12, color: '#4a5568', lineHeight: 1.6, textAlign: 'center' }}>
          Your registration is now with an administrator for approval.
          We'll email you as soon as you can sign in.
        </p>
      )}
      {state.status === 'error' && (
        <div style={alertStyle('error')}>
          {state.message}{user && ' You can send a new link from the banner in the app or from Profile settings.'}
        </div>
      )}
    </AuthCard>
  );
}
